module.exports = __webpack_public_path__ + "static/media/salt-bnb.6e7023eb.png";